import React from 'react';
import PropTypes from 'prop-types';
import Date from "components/Display/ViewDate";
import Amount from "components/Display/Amount";

import Checkbox from "jsx/elements/inputs/Checkbox";


class StatusResultTable extends React.Component {

  state = {
    showDetail : false
  };

  constructor(props){
    super(props);
    this.showDetailClick = this.showDetailClick.bind(this);
  }

  showDetailClick(){
    //console.debug("This:");
    this.setState({ showDetail: !this.state.showDetail });
  };


  render() {
    if (!this.props.data || Object.keys(this.props.data).length === 0){
      return (
        <div/>
      );
    }

    let result = this.props.data;
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="3" className="text-left"><span className="calc-setting-table-header">Niðurstaða&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <input id="checkid1" type="checkbox" checked={this.state.showDetail} onChange={this.showDetailClick}/><label className="calc-small-checkbox-label" htmlFor="checkid1" >Sýna niðurbrot</label>
            </th>

          </tr>
          <tr>
            <th className="text-left">Liður</th>
            <th className="text-right">Reiknað til <Date data={result.calculateTo}/> </th>
            <th className="text-right">Eftirstöðvar</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th className="text-left">Höfuðstóll</th>
            <td className="text-right"><Amount data={result.currentSum.principal}/></td>
            <td className="text-right"><Amount data={result.remainderSum.principal}/></td>
          </tr>
          <tr>
            <th className="text-left">Samningsvextir</th>
            <td className="text-right"><Amount data={result.currentSum.contractInterests}/></td>
            <td className="text-right"><Amount data={result.remainderSum.contractInterests}/></td>
          </tr>
          <tr>
            <th className="text-left">Bankakostnaður</th>
            <td className="text-right"><Amount data={result.currentSum.bankCost}/></td>
            <td className="text-right"><Amount data={result.remainderSum.bankCost}/></td>
          </tr>
          <tr>
            <th className="text-left">Dráttarvextir</th>
            <td className="text-right"><Amount data={result.currentSum.penaltyInterests}/></td>
            <td className="text-right"><Amount data={result.remainderSum.penaltyInterests}/></td>
          </tr>
          <tr>
            <th className="text-left">Kostnaður kröfuhafa</th>
            <td className="text-right"><Amount data={result.currentSum.creditorCost}/></td>
            <td className="text-right"><Amount data={result.remainderSum.creditorCost}/></td>
          </tr>
          <tr>
            <th className="text-left">Áfallinn kostnaður</th>
            <td className="text-right"><Amount data={result.currentSum.accruedExpense}/></td>
            <td className="text-right"><Amount data={result.remainderSum.accruedExpense}/></td>
          </tr>
          {this.state.showDetail &&
          <tr className="status-calc-sub">
            <th className="text-left">-Áfallinn kostnaður sem ber VSK</th>
            <td className="text-right"><Amount data={result.currentSum.accruedExpenseCarryVat}/></td>
            <td className="text-right"><Amount data={result.remainderSum.accruedExpenseCarryVat}/></td>
          </tr>}
          {this.state.showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Áfallinn kostnaður sem ber ekki VSK</th>
            <td className="text-right"><Amount data={result.currentSum.accruedExpenseDoesNotCarryVat}/></td>
            <td className="text-right"><Amount data={result.remainderSum.accruedExpenseDoesNotCarryVat}/></td>
          </tr>}
          <tr>
            <th className="text-left">Útlagður kostnaður</th>
            <td className="text-right"><Amount data={result.currentSum.outlaidExpense}/></td>
            <td className="text-right"><Amount data={result.remainderSum.outlaidExpense}/></td>
          </tr>
          {this.state.showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Útlagður kostnaður sem ber VSK</th>
            <td className="text-right"><Amount data={result.currentSum.outlaidExpenseCarryVat}/></td>
            <td className="text-right"><Amount data={result.remainderSum.outlaidExpenseCarryVat}/></td>
          </tr>}
          {this.state.showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Útlagður kostnaður sem ber ekki VSK</th>
            <td className="text-right"><Amount data={result.currentSum.outlaidExpenseDoesNotCarryVat}/></td>
            <td className="text-right"><Amount data={result.remainderSum.outlaidExpenseDoesNotCarryVat}/></td>
          </tr>}
          <tr>
            <th className="text-left">Vextir af kostnaði</th>
            <td className="text-right"><Amount data={result.currentSum.totalCostPenaltyInterests}/></td>
            <td className="text-right"><Amount data={result.remainderSum.totalCostPenaltyInterests}/></td>
          </tr>
          {this.state.showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Vextir af áföllnum kostnaði</th>
            <td className="text-right"><Amount data={result.currentSum.accruedPenaltyInterests}/></td>
            <td className="text-right"><Amount data={result.remainderSum.accruedPenaltyInterests}/></td>
          </tr>}
          {this.state.showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Vextir af útlögðum kostnaði</th>
            <td className="text-right"><Amount data={result.currentSum.outlaidPenaltyInterests}/></td>
            <td className="text-right"><Amount data={result.remainderSum.outlaidPenaltyInterests}/></td>
          </tr>}
          <tr>
            <th className="text-left">Virðisaukaskattur</th>
            <td className="text-right"><Amount data={result.currentSum.totalVat}/></td>
            <td className="text-right"><Amount data={result.remainderSum.totalVat}/></td>
          </tr>
          {this.state.showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Virðisaukaskattur af áföllnum kostnaði</th>
            <td className="text-right"><Amount data={result.currentSum.accruedExpenseVat}/></td>
            <td className="text-right"><Amount data={result.remainderSum.accruedExpenseVat}/></td>
          </tr>}
          {this.state.showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Virðisaukaskattur af útlögðum kostnaði</th>
            <td className="text-right"><Amount data={result.currentSum.outlaidExpenseVat}/></td>
            <td className="text-right"><Amount data={result.remainderSum.outlaidExpenseVat}/></td>
          </tr>}
          <tr>
            <th className="text-left">Afsláttur / niðurfelling</th>
            <td className="text-right"><Amount data={result.currentSum.discountsAndTerminations}/></td>
            <td className="text-right">&nbsp;</td>
          </tr>
          {this.state.showDetail &&  <tr className="status-calc-sub">
            <th className="text-left">-Afsláttur / niðurfelling kröfuhafi</th>
            <td className="text-right"><Amount data={result.currentSum.discountsAndTerminiationsCreditor}/></td>
            <td  className="text-right">&nbsp;</td>
          </tr>}
          {this.state.showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Afsláttur / niðurfelling lögmaður</th>
            <td className="text-right"><Amount data={result.currentSum.discountAndTerminationsLawyer}/></td>
            <td  className="text-right">&nbsp;</td>
          </tr>}
          <tr>
            <th className="text-left">Innborgun</th>
            <td className="text-right"><Amount data={result.currentSum.payments}/></td>
            <td  className="text-right">&nbsp;</td>
          </tr>
          {this.state.showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Innborgun kröfuhafi</th>
            <td className="text-right"><Amount data={result.currentSum.paymentsCreditor}/></td>
            <td  className="text-right">&nbsp;</td>
          </tr>}
          {this.state.showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Innborgun lögmaður</th>
            <td className="text-right"><Amount data={result.currentSum.paymentsLawyer}/></td>
            <td  className="text-right">&nbsp;</td>
          </tr>}
          <tr className="text-bold">
            <th className="text-left">Samtals</th>
            <td className="text-right"><Amount data={result.currentSum.total}/></td>
            <td  className="text-right">&nbsp;</td>
          </tr>
          {this.state.showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Ofgreitt kröfuhafi</th>
            <td className="text-right"><Amount data={result.currentSum.paymentsCreditorOverPaid}/></td>
            <td  className="text-right">&nbsp;</td>
          </tr>}
          {this.state.showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Ofgreitt lögmaður</th>
            <td className="text-right"><Amount data={result.currentSum.paymentsLawyerOverPaid}/></td>
            <td  className="text-right">&nbsp;</td>
          </tr>}
          <tr  className="text-bold">
            <th className="text-left">Ógj. eftirst. auk vaxta</th>
            <td className="text-right"><Amount data={result.currentSum.notCalledInRemainderWithInterest}/></td>
            <td className="text-right">&nbsp;</td>
          </tr>
          <tr  className="text-bold">
            <th className="text-left">Jöfnunarreik.eftirst.</th>
            <td className="text-right"><Amount data={result.currentSum.equalizationAccount}/></td>
            <td className="text-right">&nbsp;</td>
          </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

StatusResultTable.propTypes = {
  data: PropTypes.object,
};



export default StatusResultTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Results/StatusResultTable.js